/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SquareDashedBottomCode = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m10 10-2 2 2 2" }],
    ["path", { d: "m14 14 2-2-2-2" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2" }],
    ["path", { d: "M9 21h1" }],
    ["path", { d: "M14 21h1" }]
  ]
];

export { SquareDashedBottomCode as default };
//# sourceMappingURL=square-dashed-bottom-code.js.map
